import { ELSCommonUIConstants } from 'components/common';
import { analyticBaseConfig } from 'config/app.config';
import { ROUTE_ROLES, RoutePath } from 'constants/app.constant';
import { lazy } from 'react';
var ALL = ROUTE_ROLES.ALL, INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR;
export var IntegrationRoutes = {
    getRoutes: function () { return [
        {
            path: RoutePath.login,
            component: lazy(function () { return import('components/features/login/IntegrationLoginComponent'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.login,
                    pageName: "".concat(analyticBaseConfig.edApp, ":login")
                }
            },
            isPrivate: false,
            roles: ALL
        },
        {
            path: RoutePath.appLinkingLogin,
            component: lazy(function () { return import('components/features/login/IntegrationLoginComponent'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.login,
                    pageName: "".concat(analyticBaseConfig.edApp, ":app-linking-login")
                }
            },
            isPrivate: false,
            roles: ALL
        },
        {
            path: RoutePath.reportingPortal,
            component: lazy(function () { return import('components/features/centralized-landing-page/CentralizedLandingPage'); }),
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: RoutePath.footerAccessibility,
            component: lazy(function () { return import('components/common/footer-accessibility/FooterAccessibility'); }),
            isPrivate: false
        }
    ]; }
};
